/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { useFormik } from 'formik';
import { useIntl, FormattedMessage } from 'react-intl';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';
import { Checkbox } from 'components/FormInputs';

const noContactsOutside = (
  <a
    role="button"
    tabIndex="0"
    style={{ textDecoration: 'underline' }}
    onClick={(e) => {
      e.preventDefault();
      window.supportHeroWidget.show({ article: '65359-hur-fungerar-stugknutens-bokningstjaenst' });
    }}
  >
    <FormattedMessage
      id="here"
      defaultMessage="here"
    />
  </a>
);

const AcceptTermsDialog = ({
  open,
  onClose,
  onConfirm,
}) => {
  const intl = useIntl();
  const generalConditions = (
    <a
      href={intl.formatMessage({ id: 'link.terms', defaultMessage: '/en/terms' })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage
        id="general conditions"
        defaultMessage="general conditions"
      />
    </a>
  );
  const bookingTerms = (
    <a
      href={intl.formatMessage({ id: 'link.bookingterms', defaultMessage: '/en/terms-booking' })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage
        id="booking terms"
        defaultMessage="booking terms"
      />
    </a>
  );
  const formik = useFormik({
    initialValues: {
      generalConditions: false,
      bookingTerms: false,
      noContactsOutside: false,
    },
    validate: (values) => {
      const errors = {};

      if (!values.generalConditions) {
        errors.generalConditions = intl.formatMessage({
          id: 'Required',
          defaultMessage: 'Required',
        });
      }

      if (!values.bookingTerms) {
        errors.bookingTerms = intl.formatMessage({
          id: 'Required',
          defaultMessage: 'Required',
        });
      }

      if (!values.noContactsOutside) {
        errors.noContactsOutside = intl.formatMessage({
          id: 'Required',
          defaultMessage: 'Required',
        });
      }

      return errors;
    },
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    onSubmit: async () => {
      onConfirm();
    },
  });

  const {
    values, handleChange, handleSubmit, isValid,
  } = formik;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form onSubmit={handleSubmit} noValidate>
        <DialogContent>
          <DialogContentText>
            <FormattedMessage
              id="acceptTermsDialog.beforeYouSend"
              defaultMessage="Before you send your advert to us for a review, we would like you to confirm the following:"
            />
          </DialogContentText>
          <Box mb={1}>
            <Checkbox
              name="generalConditions"
              value={values.generalConditions}
              onChange={handleChange}
              label={(
                <FormattedMessage
                  id="acceptTermsDialog.generalConditions"
                  defaultMessage="I accept Stugknuten's {generalConditions}."
                  values={{ generalConditions }}
                />
              )}
            />
          </Box>
          <Box mb={2}>
            <Checkbox
              name="bookingTerms"
              value={values.bookingTerms}
              onChange={handleChange}
              label={(
                <FormattedMessage
                  id="acceptTermsDialog.bookingTerms"
                  defaultMessage="I accept Stugknuten's {bookingTerms}."
                  values={{ bookingTerms }}
                />
              )}
            />
          </Box>
          <Box>
            <Checkbox
              name="noContactsOutside"
              value={values.noContactsOutside}
              onChange={handleChange}
              label={(
                <FormattedMessage
                  id="acceptTermsDialog.noContactsOutside"
                  defaultMessage="I accept without exclusion to use Stugknuten's services for booking and payments regarding requests via Stugknuten and understand that as agreed upon, it is not permitted to offer the guest booking and payment outside of Stugknuten's system when the booking request comes via Stugknuten. More information about our services is available {noContactsOutside}."
                  values={{ noContactsOutside }}
                />
              )}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            type="submit"
            disabled={!isValid}
          >
            <FormattedMessage
              id="Continue"
              defaultMessage="Continue"
            />
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

AcceptTermsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default AcceptTermsDialog;
